// Streak and goal rules for the study companion. Plain functions, covered by tests; session-only until progress is saved per account.
export function streakMilestone(days) {
  if (days === 10) return 'streak10';
  if (days === 5) return 'streak5';
  return null;
}
export function advanceStreak(lastDay, days, today) {
  if (lastDay === today) return days;
  const difference = lastDay ? (Date.parse(`${today}T00:00:00Z`) - Date.parse(`${lastDay}T00:00:00Z`)) / 86400000 : 0;
  return difference === 1 ? days + 1 : 1;
}
export function goalReached(before, after, target) {
  return target > 0 && before < target && after >= target;
}
